// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VModal from 'vue-js-modal';
import store from './stores/index';
import mixin from './mixins/index';

Vue.config.productionTip = false;

Vue.use(VModal);
Vue.mixin(mixin);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store
});



// WEBPACK FOOTER //
// ./src/main.js